// Import for framework tools
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {updateSmallScreen} from './frameworkSlice';
import {customTheme} from '../../app/utils';
// Import dependent components
import {Sidebar} from '../Sidebar';
import {Topbar} from '../Topbar';
import ChatWrapper from '../ChatPanel';
import {PasskeyNudgeDialog} from '../PasskeyNudgeDialog';
import {createTheme, ThemeProvider} from '@mui/material/styles';

// customTheme is a static object, so the theme never changes. Building it inside render
// handed ThemeProvider a new identity on every render and invalidated the sx/styled caches
// of the entire tree below it.
const theme = createTheme(customTheme);

function Framework(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const chatIsOpen = useSelector((state) => {
    return state.chat.isOpen;
  });
  const chatOverlayDimEnabled = useSelector((state) => {
    return state.chat.overlayDimEnabled;
  });
  const isInsightsPage = location.pathname === '/insights';
  const applyChatContentDim = chatIsOpen && chatOverlayDimEnabled && !isInsightsPage;

  const [sideMenuOpened, setSideMenuOpened] = useState(false);

  function handleSetSideMenuOpened(state = undefined) {
    setSideMenuOpened((currentState) => {
      return state == undefined ? !currentState : state;
    });
  }

  useEffect(() => {
    let frame = null;

    function applyScreenSize() {
      frame = null;
      if (window.innerWidth <= 767) {
        dispatch(updateSmallScreen(true));
      } else {
        dispatch(updateSmallScreen(false));
      }
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    // A drag-resize fires `resize` on every frame. Unthrottled this dispatched to Redux
    // dozens of times a second and re-rendered every connected component in the app -
    // very visible when dragging Cropview's list/map splitter. Coalesce to one frame.
    function onResize() {
      if (frame != null) {
        return;
      }
      frame = window.requestAnimationFrame(applyScreenSize);
    }

    window.addEventListener('resize', onResize);
    applyScreenSize();
    return () => {
      // Remove event listener when component is unmounted
      window.removeEventListener('resize', onResize);
      if (frame != null) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div id='page-top'>
        <div id='wrapper'>
          <Sidebar
            activePage={props.activePage}
            sideMenuOpened={sideMenuOpened}
            handleSetSideMenuOpened={handleSetSideMenuOpened}
          />
          <div
            id='content-wrapper'
            style={{
              opacity: applyChatContentDim ? 0.3 : 1,
              transition: 'opacity 0.2s',
            }}
          >
            <div id='content'>
              <Topbar
                text={props.pageName}
                badge={props.pageBadge}
                search={props.topBarSearch != false}
                handleSetSideMenuOpened={handleSetSideMenuOpened}
              />
              {props.children}
            </div>
            {props.footer && (
              <footer className='sticky-footer bg-white'>
                <div className='container my-auto'>
                  <div className='copyright text-center my-auto'></div>
                </div>
              </footer>
            )}
          </div>
        </div>
        <ChatWrapper />
        <PasskeyNudgeDialog />
      </div>
    </ThemeProvider>
  );
}

export {Framework};
